import { render } from "./diklat-print.vue?vue&type=template&id=6f3568c0&scoped=true"
import script from "./diklat-print.vue?vue&type=script&lang=js"
export * from "./diklat-print.vue?vue&type=script&lang=js"

import "./diklat-print.vue?vue&type=style&index=0&id=6f3568c0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3568c0"]])

export default __exports__